export default {
  notificationList: {
    method: 'post',
    url: '/client/company/user/notification/list'
  },
  notificationChangeRead: {
    method: 'put',
    url: '/client/company/user/notification'
  },
  notificationClearAll: {
    method: 'put',
    url: '/client/company/user/notification/clear-all'
  }
}
